import { useState } from 'react';
import type { FutebolJogoDia } from '@/shared/types';

interface Props {
  jogo: FutebolJogoDia | null;
}

function EscudoMini({ src, nome }: { src: string | null; nome: string }) {
  const [erro, setErro] = useState(false);
  if (!src || erro) {
    return (
      <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-white/10 text-[11px] font-bold uppercase text-white/40">
        {nome.slice(0, 2)}
      </div>
    );
  }
  return (
    <img src={src} alt={nome} className="h-7 w-7 shrink-0 object-contain" onError={() => setErro(true)} />
  );
}

function horarioBRT(iso: string): string {
  return new Date(iso).toLocaleTimeString('pt-BR', {
    timeZone: 'America/Sao_Paulo',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export default function ProximoJogoWidget({ jogo }: Props) {
  if (!jogo) return null;

  return (
    <div className="relative w-full overflow-hidden rounded-2xl border border-orange-500/20 bg-white/[0.02]">
      <span className="absolute inset-y-0 left-0 w-0.5 bg-orange-400" aria-hidden />

      <div className="flex items-center justify-between px-4 pb-1 pt-3">
        <div className="flex items-center gap-1.5">
          <span className="inline-flex items-center gap-1.5 rounded-md bg-orange-500/15 px-1.5 py-0.5 text-[10px] font-bold text-orange-400 ring-1 ring-orange-500/25">
            Em breve
          </span>
          <span className="ml-0.5 font-mono text-[11px] tabular-nums text-white/45">
            {horarioBRT(jogo.horario)}
          </span>
        </div>
        {jogo.liga_nome && (
          <span className="max-w-[45%] truncate text-right text-[11px] text-white/35">{jogo.liga_nome}</span>
        )}
      </div>

      <div className="flex items-center justify-between px-4 pb-3 pt-1">
        <div className="flex min-w-0 flex-1 items-center gap-2">
          <EscudoMini src={jogo.escudo_casa ?? null} nome={jogo.time_casa} />
          <span className="truncate text-xs font-semibold text-white/90">{jogo.time_casa}</span>
        </div>

        <div className="shrink-0 px-3">
          <span className="text-base font-light text-white/35">×</span>
        </div>

        <div className="flex min-w-0 flex-1 items-center justify-end gap-2">
          <span className="truncate text-right text-xs font-semibold text-white/90">{jogo.time_visitante}</span>
          <EscudoMini src={jogo.escudo_visitante ?? null} nome={jogo.time_visitante} />
        </div>
      </div>
    </div>
  );
}
